export default __webpack_public_path__ + "static/skytale-124d800cb8a4e5319e581bec19dd777b.jpg";